export const FeedDeskEmailFormat = {
  Single: 'single',
  Digest: 'digest',
};
